(() => {
  const swatchSelector = '.t4s-product-colors .t4s-pr-color__item:not(.is--colors-more)';
  const imageWidths = [100, 200, 330, 400, 500, 600, 700, 800, 900];

  const imageUrlAtWidth = (url, width) => {
    if (!url || url === 'none') return '';
    return url.replace(/([?&]width=)\d+/, `$1${width}`);
  };

  const activateSwatch = (swatch) => {
    const card = swatch.closest('[data-product-options]');
    const colors = swatch.closest('.t4s-product-colors');
    if (!card || !colors) return;

    colors.querySelector('.is-swatch--selected')?.classList.remove('is-swatch--selected');
    swatch.classList.add('is-swatch--selected');
    card.classList.add('t4s-colors-selected');

    const image = card.querySelector('[data-pr-img]');
    const imageUrl = swatch.dataset.img;
    if (image && imageUrl && imageUrl !== 'none') {
      const srcset = imageWidths
        .map((width) => `${imageUrlAtWidth(imageUrl, width)} ${width}w`)
        .join(', ');
      const renderedWidth = Math.ceil(
        image.getBoundingClientRect().width * (window.devicePixelRatio || 1),
      );
      const sourceWidth = imageWidths.find((width) => width >= renderedWidth) || imageWidths.at(-1);

      image.setAttribute('srcset', srcset);
      image.setAttribute('data-srcset', srcset);
      image.setAttribute('src', imageUrlAtWidth(imageUrl, sourceWidth));
    }

    if (swatch.dataset.vid) {
      card.querySelectorAll('[data-pr-href]').forEach((link) => {
        const url = new URL(link.getAttribute('href'), window.location.origin);
        url.searchParams.set('variant', swatch.dataset.vid);
        link.setAttribute('href', `${url.pathname}${url.search}${url.hash}`);
      });
    }
  };

  document.addEventListener('click', (event) => {
    const swatch = event.target.closest(swatchSelector);
    if (swatch) activateSwatch(swatch);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    const swatch = event.target.closest(swatchSelector);
    if (!swatch) return;
    event.preventDefault();
    activateSwatch(swatch);
  });

  document.addEventListener('pointerover', (event) => {
    if (event.pointerType !== 'mouse' || !window.matchMedia('(hover: hover)').matches) return;
    const swatch = event.target.closest(swatchSelector);
    if (!swatch || swatch.contains(event.relatedTarget)) return;
    activateSwatch(swatch);
  });
})();
